/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'

 
export const getAllOrg = createAsyncThunk('org/getAllOrg', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.organization.getAllOrg()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrgHistory = createAsyncThunk('org/getAllOrgHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.organization.getAllOrgHistory(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
